import React, { useState, useEffect, Fragment, useRef, createRef } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import FormSection from 'components/sales/formSection/formSection';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';

const GatesForm = ({
  gateTypeList = null,
  typeList,
  leadGates,
  fetchLeadGate,
  handleValue = null,
  leadId,
  title = localization.gateDetails+' (Number Of Gates :'+leadGates.no_of_gate+')',
  inputTitle = localization.tagNo,
  dropdownTitle = localization.gateFeature,
  handleDataFilter = null,
  handleremoveValue = null,
  noTag = false,
}) => {
  const objInput = { current_setup_id: '', gate_no: '' };
  const [inputList, setInputList] = useState([]);
  const [inputListData1, setInputListData1] = useState('');
  const [inputListData2, setInputListData2] = useState('');
  const [inputValue, setInputValue] = useState([objInput]);
  const [isCurrentRef, setIsCurrentRef] = useState(0);
  const [isError, setIsError] = useState(false);
  const [catVal, setCatVal] = useState('');
  const [numberVal, setNumberVal] = useState('');
  const inputRef = useRef([]);

  

/*   useEffect(() => {
    if (gateTypeList)
      (async () => {
        await gateTypeList();
      })();
  }, []); */

  useEffect(() => {
    handleGates();
  }, [inputValue]);

  const handleGates = (value) => {
        // console.log('asdf');
        // console.log(leadId);
        
        handleValue({
          lead_id: leadId,
        });

  };
  
  return (
    <Fragment>
      <FormSection>
        
        <h2>Are you sure you want to submit the Presales data?</h2>
      </FormSection>
    </Fragment>
  );
};

export default GatesForm;
